import "./chooseplans.css";
import RecessPImage1 from "../../../Assets/Images/gr1.png";
import RecessPImage2 from "../../../Assets/Images/gr2.png";
import RecessPImage3 from "../../../Assets/Images/gr3.png";
import schoolProgramsEle from "../../../Assets/Images/school-programs-ele-full.png";
import schoolProgramsWhole from "../../../Assets/Images/school-programs-ele-whole.png";
import schoolProgramsInter from "../../../Assets/Images/school-programs-inter-full.png";
import PricingBlock from "./PricingBlock";

const ChoosePlanss = () => {
  const plans = [
    {
      color: "#ff5151",
      title: "Elementary Full Grade",
      price: "$ 1,175",
      features: [
        "Based on 3 lunch periods",
        "1 or more sessions pricing",
        "$1,175 for three instructors",
        "$1,025 for two instructors",
      ],
      image: schoolProgramsEle,
      bottomImage: RecessPImage1,
    },
    {
      color: "#ff5151",
      title: "Elementary Whole School",
      price: "$ 1,025",
      features: [
        "Based on 3 lunch periods",
        "1 or more sessions pricing",
        "$1,025 for three instructors",
        "$875 for two instructors",
      ],
      image: schoolProgramsWhole,
      bottomImage: RecessPImage2,
    },
    {
      color: "#ff5151",
      title: "Intermediate Full Grade",
      price: "$ 925",
      features: [
        "Based on 3 lunch periods",
        "1 or more sessions pricing",
        "$925 for four instructors",
        "$775 for three instructors",
      ],
      image: schoolProgramsInter,
      bottomImage: RecessPImage3,
    },
  ];

  return (
    <div className="choose-plans">
      <div className="choose-plans-heading">
        <h2>Choose Your Plan</h2>
      </div>

      <div className="choose-plans-list">
        {plans.map((plan, index) => (
          <PricingBlock
            key={index}
            title={plan.title}
            price={plan.price}
            features={plan.features}
            image={plan.image}
            color={plan.color}
            bottomImage={plan.bottomImage}
          />
        ))}
      </div>
    </div>
  );
};
export default ChoosePlanss;
